export enum DocumentsEvents {
  ToolTipClick = 'tooltip_click',
}
